import React from "react";
import { BorderedButton, GradientBorderBox } from "../../../../Components";
import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AmazingProductsCard from "./AmazingProductsCard";
import { useNavigate } from "react-router-dom";
import NorthWestIcon from "@mui/icons-material/NorthWest";

export default function AmazingProducts({ products = [] }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");

  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const isMedium = useMediaQuery(theme.breakpoints.between("md", "xxl"));
  const isLarge = useMediaQuery(theme.breakpoints.between("xxl", "exl"));
  const isExtraLarge = useMediaQuery(theme.breakpoints.up("exl"));

  // Decide maxItems based on which breakpoint is active
  let maxItems = 0; // default for small
  if (isMedium) maxItems = 1;
  if (isLarge) maxItems = 2;
  if (isExtraLarge) maxItems = 3;

  const items = products?.map((pr, index) => {
    if (index <= maxItems) {
      return <AmazingProductsCard key={index} pr={pr} />;
    }
  });
  return (
    <>
      <Container maxWidth={"exl"} sx={{ pb: "5rem", mt: "5rem" }}>
        <Stack
          direction={"row"}
          sx={{
            alignItems: "center",
            position: "relative",
            p: "1rem",
            mt: "18rem",
            minHeight: "140px",
          }}
        >
          {/* content */}
          <Stack
            direction={{ xs: "row", lg: "column" }}
            sx={{
              textAlign: "center",
              position: { xs: "absolute", lg: "static" },
              bottom: "100%",
              left: "50%",
              transform: {
                xs: "translate(-50% , -480%)",
                lg: "translate(0% , 0%)",
              },
              width: { xs: "100%", lg: "auto" },
              justifyContent: { xs: "space-between", lg: "start" },
            }}
          >
            <Stack
              sx={{
                width: { xs: "50%", lg: "100%" },
                alignItems: "center",
                transform: { xs: "translateX(-50%)", lg: "translateX(0%)" },
              }}
            >
              <Typography sx={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                محصولات
              </Typography>
              <Typography
                sx={{
                  color: theme.palette.primary.main,
                  display: "block",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              >
                شگفت انگیز
              </Typography>
            </Stack>
            <Button
              onClick={() => navigate("products/@amazing")}
              variant="contained"
              sx={{
                fontSize: "inherit",
                fontWeight: "bold",
                borderRadius: "10px",
                color: "white",
                bgcolor: "transparent",
                position: "relative",
                height: "50px",
                width: { xs: "50px", lg: "auto" },
                zIndex: "20",
                mt: ".5rem",
                minWidth: "0",
                ":hover" : {
                  bgcolor:"rgba(59, 59, 59, 0.2)"
                }
              }}
            >
              {isMobile ? <NorthWestIcon /> : " مشاهده همه"}
              <GradientBorderBox
                inside={true}
                radius={isMobile ? "50%" : "10px"}
              />
            </Button>
          </Stack>

          {/* Items */}
          {products?.length <= 0 ? (
            <Stack
              sx={{
                justifyContent: "center",
                alignItems: "center",
                width: "80%",
                mx: "auto",
              }}
            >
              <Typography>تعداد محصولات کافی نمیباشد !</Typography>
            </Stack>
          ) : (
            <Stack
              direction={"row"}
              sx={{
                gap: "1rem",
                justifyContent: "space-between",
                position: "absolute",
                // top:"50%",
                // transform:"translateY(-50%)",
                left: { xs: "50%", lg: "2rem" },
                transform: {
                  xs: "translate(-50% , 0%)",
                  lg: "translate(0% , 0%)",
                },
                bottom: "1rem",
              }}
            >
              {items}
            </Stack>
          )}

          <GradientBorderBox />
          {/* Circle Images left Center */}

          <Box
            sx={{
              position: "absolute",
              bottom: "-40%",
              left: "-18%",
              // transform: "translate(-40% , 70%)",
              zIndex: "-10",
              width: { xs: "180px", md: "320px", xxl: "620px" },
              height: { xs: "180px", md: "320px", xxl: "620px" },
              opacity: ".7",
            }}
          >
            <img
              style={{ width: "100%", height: "100%" }}
              src="/Media/Circles/circle.svg"
              alt="circle images"
            />
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: "40%",
              right: "-10%",
              // transform: "translate(-40% , 70%)",
              zIndex: "-10",
              width: { xs: "110px", md: "200px", xxl: "350px" },
              height: { xs: "110px", md: "200px", xxl: "350px" },
              opacity: ".7",
            }}
          >
            <img
              style={{ width: "100%", height: "100%" }}
              src="/Media/Circles/circle.svg"
              alt="circle images"
            />
          </Box>
        </Stack>
      </Container>
    </>
  );
}
